<template>
  <div class="main">
    <!-- title -->
    <div class="subTitle">
      <el-link
        icon="el-icon-arrow-left"
        :underline="false"
        href="#/customerServiceHotline"
        >Content Management - Customer Service Hotline</el-link
      >
    </div>
    <h3 class="title" content="edit" placement="bottom">
      Edit Customer Service Hotline
    </h3>
    <div class="detailContent">
      <el-form
        label-width="50%"
        label-position="left"
        ref="formHotline"
        :model="formHotline"
        :rules="formHotlineRules"
      >
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Country / Region" prop="country">
              <el-select v-model="formHotline.country" filterable>
                <el-option
                  v-for="(item, index) in countryList"
                  :key="index"
                  :label="item.name"
                  :value="item.countryId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Tel Number" prop="tel">
              <el-input v-model="formHotline.tel" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Post online" prop="post">
              <el-radio v-model="formHotline.post" :label="true">On</el-radio>
              <el-radio v-model="formHotline.post" :label="false">Off</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Order" prop="order">
              <el-input v-model="formHotline.order" maxlength="2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Last update by">
              <p>{{ formHotline.updateBy }}</p>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-row style="padding: 25px 0" type="flex" justify="end" :gutter="20">
      <el-col :span="4">
        <el-button v-if="showSave" class="reset" style="width: 100%" @click="handleCancel"
          >Cancel</el-button
        >
      </el-col>
      <el-col :span="4">
        <el-button
          v-if="showSave"
          type="primary"
          style="width: 100%"
          @click="handleSave"
          >Save</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  getCountry,
  serviceHotlineDetail,
  serviceHotlineUpdate,
} from "@/request/api";
export default {
  name: "editServiceHotline",
  data() {
    var telValidator = (rule, value, callback) => {
      let pattern = /^(?:(?:\+|00))?((\d| ){0,})$/;
      if (pattern.test(value)) {
        callback();
      } else {
        callback(new Error("Please enter the correct format"));
      }
    };
    var orderValidator = (rule, value, callback) => {
      let pattern = /^[1-9]\d*$/;
      if (pattern.test(value)) {
        callback();
      } else {
        callback(new Error("Order must be integer"));
      }
    };
    return {
      formHotlineRules: this.$validation.hotlineCreate,
      formHotline: {
        country: "",
        post: false,
        tel: "",
        order: "",
        updateBy: "",
      },
      countryList: [],
      showSave: true,
    };
  },
  methods: {
    getConfig(callback) {
      getCountry().then((res) => {
        this.countryList = res.data;
        if (callback) callback();
      });
    },
    handleCancel() {
      this.$router.push("/customerServiceHotline");
    },
    handleSave() {
      this.$refs.formHotline.validate((valid) => {
        if (valid) {
          let params = {
            countryId: this.formHotline.country,
            displayOrder: this.formHotline.order,
            phoneNumber: this.formHotline.tel,
            post: this.formHotline.post,
          };
          let id = this.$route.params.id;
          serviceHotlineUpdate(id, params).then((res) => {
            if (res.data.status == "00") {
              this.$message.success("The changes have been saved");
              this.handleCancel();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    getDetail() {
      let id = this.$route.params.id;
      serviceHotlineDetail(id).then((res) => {
        if (res.data.status == "00") {
          this.formHotline.country = res.data.payload.countryId;
          this.formHotline.tel = res.data.payload.phoneNumber;
          this.formHotline.post = res.data.payload.post;
          this.formHotline.order = res.data.payload.displayOrder;
          this.formHotline.updateBy =
            res.data.payload.updatedByName && res.data.payload.updatedAt
              ? res.data.payload.updatedByName +
                " , " +
                this.$commonjs.paramFormatDate(res.data.payload.updatedAt)
              : "-";
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    showBtn(val) {
      console.log(this.$store.state.permissions);
      var permissions = this.$store.state.permissions.filter(
        (item) => item == val
      );
      if (!permissions[0]) {
        this.showSave = false;
      }
    },
  },
  created: function () {
    this.getConfig(this.getDetail());
    this.showBtn("CONTENT_WRITE");
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/content/serviceHotline/editServiceHotline.vue